import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { openAuthModal, setCredentials } from '../../store/slices/authSlice';
import './CounselorCard.css';
import Button from '../Button/Button';
import MessageIcon from '../../assets/icons/messageIcon.svg';
import RibbonIcon from '../../assets/icons/Ribbon.svg';
import PhoneIcon from '../../assets/icons/phoneCalling.svg';
import { IoArrowForward } from 'react-icons/io5';
import { FaHeart, FaRegGrinHearts, FaRegHeart, FaUserCircle } from 'react-icons/fa';
import { useSaveCounsellorMutation, useUnsaveCounsellorMutation } from '../../store/api/userApiSlice';



const CounselorCard = ({ counselor }) => {
  const [imgError, setImgError] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
    const [saveCounsellor] = useSaveCounsellorMutation();
  const [unsaveCounsellor] = useUnsaveCounsellorMutation();
      const user = useSelector((state) => state.auth.userInfo);
  const token = useSelector((state) => state.auth.token);





   

  // Data Mapping
  // Image: Try profilePictures array first, then imageUri
  const imageUrl = (counselor.profilePictures && counselor.profilePictures.length > 0) 
    ? counselor.profilePictures[0] 
    : counselor.imageUri;
    
  const hasImage = imageUrl && !imgError;
  const counselorName = counselor.name || 'Counselor Name';
  // Role: 'expert' seemed to be the field in description, but checking fallback. 
  // Api data might have 'expert' as string or array. If array join it.
  const counselorRole = Array.isArray(counselor.expert) ? counselor.expert.join(', ') : (counselor.expert || counselor.role || 'Career Counselor');
  
  const isVerified = counselor.adminVerified === true;
  const description = counselor.bio || counselor.description || "No description available.";
  const experience = counselor.yearExp || counselor.totalExperience || "0";
  const rating = counselor.rating ? parseFloat(counselor.rating).toFixed(1) : "4.8";
  const reviews = counselor.numReviews || counselor.totalReviews || "0";
  
  const handleBookSession = () => {
    navigate(`/counsellor-profile/${counselor._id || counselor.id}`, { state: { counselor } });
  };
  // Favorite Logic
  const counselorId = counselor._id || counselor.id;
  // Ensure we check against an array, defaulting to empty if undefined
  const savedList = user?.savedCounsellors || [];
  const isFavorite = savedList.includes(counselorId);

  const toggleFavorite = async (e) => {
    e.stopPropagation();
    
    if (!user || !token) {
      dispatch(openAuthModal('login'));
      return;
    }

    const action = isFavorite ? unsaveCounsellor : saveCounsellor;
    const payload = { counsellorId: counselorId };

    console.log('[Debug] Toggling Favorite:', { isFavorite, payload, counselorId });

    try {
      const res = await action(payload).unwrap();
      console.log('[Debug] API Response:', res);
      
      // Validation: Ensure the response contains the updated list before dispatching
      // Some APIs might return the whole user object or just the list.
      // Adjust based on typical API behavior. If undefined, we don't wipe.
      let newSavedList = res.savedCounsellors || res.data?.savedCounsellors;

      if (!newSavedList) {
         console.warn('[Debug] API returned empty/invalid list. Falling back to local update.');
         // Fallback: If API doesn't return list, update locally
         if (isFavorite) {
            newSavedList = savedList.filter(id => id !== counselorId);
         } else {
            newSavedList = [...savedList, counselorId];
         }
      }

      dispatch(setCredentials({
        userInfo: { ...user, savedCounsellors: newSavedList },
        token
      }));
    } catch (error) {
      console.error('[Debug] Failed to toggle favorite:', error);
      // Optional: Show toast error here
    }
  };

  return (
    <div className="counselor-card" style={{ cursor: 'pointer' }} onClick={handleBookSession}>
      <div className="counselor-image-wrapper">
        {hasImage ? (
          <img 
            src={imageUrl} 
            alt={counselorName} 
            className="counselor-image"
            onError={() => setImgError(true)}
          />
        ) : (
          <div className="counselor-placeholder-icon" style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f5f5f5', color: '#ccc' }}>
            <FaUserCircle size={60} />
          </div>
        )}

        <button className="favorite-btn" onClick={toggleFavorite}>
          {isFavorite ? <FaHeart color='#088579' /> : <FaRegHeart />}
        </button>

       
       
      </div>
      
      <div className="counselor-info">
        <h3 className="counselor-name">{counselorName}</h3>
        
        <div className="counselor-role-wrapper">
          <p className="counselor-role">{counselorRole}</p>
          {isVerified && (
            <div className="verified-badge">
              <img src={RibbonIcon} alt="Verified" />
              <span>Verified</span>
            </div>
          )}
        </div>

        <p className="counselor-description">
          {description}
        </p>
        
        <div className="counselor-stats">
          <span className="experience-badge">{experience}+ Years Exp</span>
          <div className="counselor-rating">
            <span className="rating-star">⭐ {rating}</span>
            <span className="rating-count">({reviews})</span>
          </div>
        </div>
        
        <div className="counselor-actions">
          <Button variant="outline" className="book-btn" showArrow={false} onClick={handleBookSession}>
            BOOK A SESSION <IoArrowForward />
          </Button>
          <div className="action-icons">
            <button className="icon-btn">
              <img src={MessageIcon} alt="Message" />
            </button>
            <button className="icon-btn">
              <img src={PhoneIcon} alt="Call" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CounselorCard;
